<div class="mt-5">
  <hr />
  <div style="text-align: center;">footer works!</div>
</div>
